import { useMutateRequest } from "@ch/api/useMutation";
import { MedicationpassportControllerService } from "@ch/generated";
import useFirebaseAnalytics from "@ch/helpers/utils/firebase/hooks/useFirebaseAnalytics";
import { FirebaseEventEnum } from "@ch/helpers/utils/firebase/types";
import { NotifySuccess } from "@ch/helpers/utils/helpers";
import { useQueryClient } from "@tanstack/react-query";

const useDeleteMedicationPassport = ({
  id,
  callback,
}: {
  id?: string;
  callback?: () => void;
}) => {
  const { LogEvent } = useFirebaseAnalytics();
  const queryClient = useQueryClient();

  const { trigger, loading } = useMutateRequest({
    service:
      MedicationpassportControllerService.medicationpassportControllerDeleteById.bind(
        MedicationpassportControllerService,
      ),
    tag: "medicationpassportControllerFind",
    payload: {
      id: id ?? "",
    },
    onSuccess: () => {
      NotifySuccess("Medication deleted successfully!");
      LogEvent(FirebaseEventEnum.HEALTH_PASSPORT_DELETE, {
        passportType: "medication",
        extra: {
          id,
        },
      });
      void queryClient.invalidateQueries({
        queryKey: [],
      });
      callback?.();
    },
  });

  return {
    deleteMedicationPassport: trigger,
    loading,
  };
};

export default useDeleteMedicationPassport;
